import React from 'react'

import { Skeleton } from '@rewardops/ui'

export const loadingCardStyling =
  'flex flex-col gap-1 min-h-[250px] md:min-h-[350px] lg:min-h-[350px] pb-2 cursor-pointer md:rounded-lg sm:rounded-none md:border border-b border-r sm:-mx-px border-zinc-200 hover:shadow-[0_3px_8px_0px_rgba(0,0,0,0.2)]'

export const ItemCardSkeleton: React.FC = () => {
  return (
    <div className={loadingCardStyling}>
      <div className="relative mx-8 mt-8 h-[230px]">
        <Skeleton className="h-[230px] w-full" />
      </div>
      <div className="m-8 space-y-2.5">
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-full" />
      </div>
    </div>
  )
}

export default ItemCardSkeleton
